export default __webpack_public_path__ + "static/media/ocr_no_checked.d152a025.svg";